<div
  #launcher
  class="ui launcher"
  (click)="openLauncher()"
  [style.backgroundColor]="currentApp.color"
>
  <svg-icon [src]="currentApp.iconUrl"></svg-icon>
</div>

<div
  class="ui left sidebar borderless inverted vertical menu animating"
  [ngClass]="isActive ? 'overlay visible' : ''"
>
  <div
    class="app header"
    [style.backgroundColor]="currentApp.color"
  >
    <svg-icon [src]="currentApp.iconUrl"></svg-icon>
  </div>

  <a
    *ngFor="let app of apps | sortBy:sortByAttr"
    [attr.href]="app.appUrl"
    [attr.target]="'_self'"
    class="item app"
    [class.active]="currentApp === app"
  >
    <svg-icon [src]="app.iconUrl" [style.fill]="app.color"></svg-icon><span>{{app.title}}</span>
  </a>
</div>
